"use client";

export function Footer() {
  return (
    <footer className="relative bg-ink text-cream mt-auto">
      {/* Top hairline */}
      <div className="h-px bg-gradient-to-r from-transparent via-gold/60 to-transparent"></div>

      <div className="mx-auto max-w-7xl px-6 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10 md:gap-14">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <span className="relative inline-flex h-10 w-10 items-center justify-center rounded-full border border-gold/40">
                <span className="font-display italic text-gold text-2xl leading-none">
                  O
                </span>
                <span className="absolute -top-1 -right-1 text-gold text-xs">
                  ✦
                </span>
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-display text-cream text-2xl tracking-wide">
                  Hyper <span className="gold-text italic">OR</span> I
                </span>
                <span className="text-[10px] tracking-[0.3em] uppercase text-cream/50 mt-1">
                  SENE &amp; DIA
                </span>
              </div>
            </div>
            <p className="text-cream/55 font-serif text-base leading-relaxed max-w-sm">
              L&apos;hypermarché de référence en France. Douze univers
              d&apos;exception au cœur du boulevard Haussmann. SmarTest Capital,
              depuis 2019.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {["IG", "FB", "X", "PIN"].map((s) => (
                <a
                  key={s}
                  href="#"
                  aria-label={s}
                  className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-cream/15 text-cream/60 hover:border-gold hover:text-gold text-[10px] tracking-wider transition-colors"
                >
                  {s}
                </a>
              ))}
            </div>
          </div>

          {/* Columns */}
          <div className="md:col-span-2">
            <h4 className="text-cream/40 text-[10px] tracking-[0.3em] uppercase mb-4">
              Maison
            </h4>
            <ul className="space-y-2.5">
              {[
                "Notre histoire",
                "Engagements",
                "Recrutement",
                "Presse",
                "Espace pro",
              ].map((x) => (
                <li key={x}>
                  <a
                    href="#about"
                    className="text-cream/70 hover:text-gold text-sm transition-colors"
                  >
                    {x}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-cream/40 text-[10px] tracking-[0.3em] uppercase mb-4">
              Services
            </h4>
            <ul className="space-y-2.5">
              {[
                "Conciergerie",
                "Click & Collect",
                "Livraison Paris",
                "Cave personnalisée",
                "Carte cadeau",
              ].map((x) => (
                <li key={x}>
                  <a
                    href="#services"
                    className="text-cream/70 hover:text-gold text-sm transition-colors"
                  >
                    {x}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-cream/40 text-[10px] tracking-[0.3em] uppercase mb-4">
              Aide
            </h4>
            <ul className="space-y-2.5">
              {["Contact", "FAQ", "Retours", "CGV", "Mentions légales"].map(
                (x) => (
                  <li key={x}>
                    <a
                      href="#location"
                      className="text-cream/70 hover:text-gold text-sm transition-colors"
                    >
                      {x}
                    </a>
                  </li>
                )
              )}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-cream/40 text-[10px] tracking-[0.3em] uppercase mb-4">
              Adresse
            </h4>
            <address className="not-italic text-cream/70 text-sm leading-relaxed">
              12 Boulevard Haussmann
              <br />
              75009 Paris
              <br />
              <br />
              <a
                href="tel:+33142311000"
                className="hover:text-gold transition-colors"
              >
                +33 1 42 31 10 00
              </a>
              <br />
              <a
                href="mailto:contact@hyper-or.fr"
                className="hover:text-gold transition-colors"
              >
                contact@hyper-or.fr
              </a>
            </address>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-14 pt-6 border-t border-cream/10 flex flex-col md:flex-row items-center justify-between gap-4 text-cream/40 text-[11px] tracking-[0.2em] uppercase">
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <span>© MMXIX Hyper OR I</span>
            <span className="text-cream/20">·</span>
            <span>SENE &amp; DIA</span>
            <span className="text-cream/20">·</span>
            <span>SmarTest Capital</span>
          </div>
          <div className="flex items-center gap-4">
            <span>Paris 9ᵉ · Haussmann</span>
            <span className="text-cream/20">·</span>
            <span>08h–22h · 7j/7</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
